
import {finalize} from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import {FreighterLoaderTariff} from "../_models/freighter-loader-tariff";
import {FreighterLoaderTariffService} from "../_services/freighter-loader-tariff.service";
import {LoaderService} from "../_services/loader.service";
import {AlertService} from "../_services/alert.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-new-loader-tariff',
  templateUrl: './new-loader-tariff.component.html',
  styleUrls: ['./new-loader-tariff.component.css']
})
export class NewLoaderTariffComponent implements OnInit {
  tariff = new FreighterLoaderTariff();

  constructor(
    private freighterLoaderTariffService: FreighterLoaderTariffService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    private router: Router
  ) { }

  ngOnInit() {
  }

  submit() {
    this.loaderService.show();
    this.freighterLoaderTariffService
      .addTariff(this.tariff).pipe(
      finalize(() => this.loaderService.hide()))
      .subscribe(
        () => {
          this.alertService.success('Тариф добавлен', true);
          this.router.navigate(['/tariffs/loaders']);
        },
        () => {}
      )
  }

  onSubmit() {
    this.submit();
  }
}
